import React from 'react'
import ArenaTable from './ArenaTable';
import { TableObject } from './TableObject';

export default function Arena75Table({ totalTables, toggleTableSelection, BaseURL, translate, renderPrice = false }) {
    return <div className="bookingTableContainer" style={{ width: 1350 }}>
        <div className="bookingTablesRow" style={{ marginLeft: 50 }}>
            {totalTables
                .filter((item, index) => item.tableNo > 65 && item.tableNo < 80).reverse()
                .map((item, index) => (
                    index < 20 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        renderPrice={renderPrice}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            {/* <div className="vipSection" style={{ marginLeft: 15 }}>{translate('web.judgesNotForSelleing', 'Judges Not For Selleing')}</div> */}

            {/* Refactor to be part of map */}

        </div>
        <div className="bookingTableCenter">
            <div className="bookingTablesColumn" style={{ marginRight: 10 }}>
                {totalTables
                    .filter((item, index) => item.tableNo > 55 && item.tableNo < 66)
                    .map((item, index) => (
                        index < 10 &&
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableNo}
                            renderPrice={renderPrice}
                            tablePrice={item.price}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)} />
                    ))}
            </div>
            <div className="bookingTablesColumn" style={{ marginRight: 10 }}>
                {totalTables
                    .filter((item, index) => item.tableNo > 45 && item.tableNo < 56)
                    .map((item, index) => (
                        index < 10 &&
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableNo}
                            tablePrice={item.price}
                            renderPrice={renderPrice}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)} />
                    ))}
            </div>
            <div className="bookingTablesColumn" style={{ marginRight: 10 }}>
                {totalTables

                    .filter((item, index) => item.tableNo > 34 && item.tableNo < 46)
                    .map((item, index) => (
                        index < 11 &&
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableNo}
                            tablePrice={item.price}
                            renderPrice={renderPrice}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)} />
                    ))}
            </div>
            <div className="BookingTableArena">
                <img
                    style={{ background: '#A67B52' }}
                    src={`${BaseURL}/assets/img/HorseArena.png`}
                    alt="Horse Arena" />
            </div>
        </div>
        <div className="bookingTablesRow withVIPSection" style={{ marginLeft: 100 }}>
            {totalTables
                .filter((item, index) => item.tableNo > 6 && item.tableNo < 13)
                .map((item, index) => (
                    index < 7 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice={renderPrice}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables

                .filter((item, index) => item.tableNo < 7)
                .map((item, index) => (
                    index < 6 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice={renderPrice}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
        </div>
        <div className="bookingTablesRow withVIPSection secondVIPRow" style={{ marginLeft: 50 }}>
            {totalTables

                .filter((item, index) => item.tableNo > 17 && item.tableNo < 24)
                .map((item, index) => (
                    index < 6 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice={renderPrice}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables
                .filter((item, index) => item.tableNo > 12 && item.tableNo < 18)
                .map((item, index) => (
                    index < 5 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice={renderPrice}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
        </div>
        <div className="bookingTablesRow withVIPSection secondVIPRow" style={{ marginLeft: 50 }}>
            {totalTables

                .filter((item, index) => item.tableNo > 28 && item.tableNo < 35)
                .map((item, index) => (
                    index < 6 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice={renderPrice}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables
                .filter((item, index) => item.tableNo > 23 && item.tableNo < 29)
                .map((item, index) => (
                    index < 5 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableNo}
                        tablePrice={item.price}
                        renderPrice={renderPrice}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)} />
                ))}
            <div style={{ marginLeft: 75, textAlign: 'center', maxWidth: 40, marginTop: 50 }}>
                <div style={{ width: 20, height: 10, background: '#409A97' }} />
                <div style={{ marginLeft: -10, }}>
                    <i class="fa-solid fa-up-long" style={{ color: '#409A97' }}></i>
                </div>
                <div style={{ fontSize: 13, width: 125, marginLeft: '-0px', textAlign: 'left' }}>{translate('web.audienceEntrance', 'Audience Entrance')}</div>
            </div>
        </div>
    </div>;
}
